const FuelToolTipStyles = (theme) => {
  return {
    priceTooltip: {
      width: 400,
        minWidth: 400,
          maxWidth: 400,
    } 
  }
}
export default FuelToolTipStyles;